import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arraySlice',
  standalone: true
})
export class ArraySlicePipe implements PipeTransform {

  public transform<T>(arr: T[], start?: number, end?: number): T[] {
    return arr.slice(start, end);
  }
}
